module.exports = __webpack_public_path__ + "img/sld_scb_4_green.d2175ff0.svg";